(function () {
    'use strict';

    var module = angular.module('uwAgenda.website');
    module.directive('websiteGeneratorUserFilter', ['WebsiteGeneratorService', websiteGeneratorUserFilterFn]);

    // filter directive for multiple shared agenda selection
    function websiteGeneratorUserFilterFn(WebsiteGeneratorService) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/website-generator/templates/website-generator-user-filter.template.html',
            scope: {
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // is filter collapsed or not
            scope.WebsiteGeneratorService = WebsiteGeneratorService;
            scope.toggleUser = function($event,id){
                $event.stopPropagation();
                WebsiteGeneratorService.data.filterData.sharedAgendas.forEach(agenda=>{
                    if(agenda.owner.id===id){
                        agenda.owner.selectedInWebsiteLinkConfiguration = !agenda.owner.selectedInWebsiteLinkConfiguration;
                    }
                })
                WebsiteGeneratorService.refreshLinks();
            }
        } // link
    }
})();